import { Component } from '@angular/core';
import { NavParams, Events } from 'ionic-angular';
import { EventCodes } from '../core/codes';

@Component({
	templateUrl: 'popover-checkbox-select.html'
})

export class PopoverCheckboxSelect {
	public listName: any;
	public items: any;

	constructor(
    	public params: NavParams,
    	private events: Events
    ) {	
    	this.initData();
    }

	ionViewDidEnter() {
	}

	public initData(){
		this.listName = this.params.get("listName");
		this.items = this.params.get("items");
	}

	public itemClicked(item){
		this.events.publish(EventCodes.POPOVER_CHECKBOX_CHANGED, item);
	}
}



// WEBPACK FOOTER //
// ./src/components/popover-checkbox-select.ts